import { jsx as _jsx } from "react/jsx-runtime";
import Script from 'next/script';
import { memo } from 'react';
export var GoogleTagManagerScript = /*#__PURE__*/memo(function GoogleTagManagerScript(_ref) {
  var id = _ref.id;

  if (false || !id) {
    return null;
  }

  return /*#__PURE__*/_jsx(Script, {
    id: "google-tag-manager",
    strategy: "afterInteractive",
    dangerouslySetInnerHTML: {
      __html: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n          })(window,document,'script','dataLayer','".concat(id, "');")
    }
  });
});
export var GoogleTagManagerNoScript = /*#__PURE__*/memo(function GoogleTagManagerNoScript(_ref2) {
  var id = _ref2.id;

  if (false || !id) {
    return null;
  }

  return /*#__PURE__*/_jsx("noscript", {
    dangerouslySetInnerHTML: {
      __html: "<iframe src=\"https://www.googletagmanager.com/ns.html?id=".concat(id, "\"\n            height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>")
    }
  });
});